import { actionTypeCreator } from './util'
import { createSelector } from 'reselect'

import * as fromEntities from '@src/redux/modules/entities'

// /////////////////////////////////////////////////////////////////////////////
// Constants
// /////////////////////////////////////////////////////////////////////////////
export const constants = {
  NAME: 'search'
}

// /////////////////////////////////////////////////////////////////////////////
// Action Types
// /////////////////////////////////////////////////////////////////////////////
const createActionType = actionTypeCreator.bind(undefined, constants.NAME)
export const SEARCH = createActionType('SEARCH')
export const SEARCH_STARTED = createActionType('SEARCH_STARTED')
export const SEARCH_SUCCESS = createActionType('SEARCH_SUCCESS')
export const SEARCH_ERROR = createActionType('SEARCH_ERROR')

export const SEARCH_MY_ALIADAS = createActionType('SEARCH_MY_ALIADAS')
export const SEARCH_MY_ALIADAS_STARTED = createActionType('SEARCH_MY_ALIADAS_STARTED')
export const SEARCH_MY_ALIADAS_SUCCESS = createActionType('SEARCH_MY_ALIADAS_SUCCESS')
export const SEARCH_MY_ALIADAS_ERROR = createActionType('SEARCH_MY_ALIADAS_ERROR')

// /////////////////////////////////////////////////////////////////////////////
// Actions
// /////////////////////////////////////////////////////////////////////////////
export function search (querystring) {
  return {
    type: SEARCH,
    payload: {
      querystring
    }
  }
}

export function searchMyAliadas (querystring) {
  return {
    type: SEARCH_MY_ALIADAS,
    payload: {
      querystring
    }
  }
}

// /////////////////////////////////////////////////////////////////////////////
// Queries
// /////////////////////////////////////////////////////////////////////////////
export const isSearching = (state) => state[constants.NAME].searching
export const isSearchingMyAliadas = (state) => state[constants.NAME].searchingMyAliadas

// /////////////////////////////////////////////////////////////////////////////
// Selectors
// /////////////////////////////////////////////////////////////////////////////
const getState = (state) => state[constants.NAME]
export const getStatus = createSelector(getState, state => state.status)
export const getResults = createSelector(getState, state => state.results)
export const getMyAliadasResults = createSelector(getState, state => state.myAliadasResults)
export const getQuerystring = createSelector(getState, state => state.querystring)
export const getAvailableAliadas = createSelector(
  getResults,
  fromEntities.getAliadas,
  (results, aliadas) => results.map(id => aliadas[id])
)

export const getAvailableMyAliadas = createSelector(
  getMyAliadasResults,
  fromEntities.getAliadas,
  (results, aliadas) => results.map(id => aliadas[id])
)

// /////////////////////////////////////////////////////////////////////////////
// Reducer
// /////////////////////////////////////////////////////////////////////////////
const initialState = {
  querystring: '',
  results: [],
  myAliadasResults: [],
  searching: false,
  status: '',
  searchingMyAliadas: false,
  error: ''
}

export function reducer (state = initialState, action = {}) {
  const payload = action.payload
  switch (action.type) {
    case SEARCH_STARTED:
      return {
        ...state,
        searching: true,
        error: '',
        status: ''
      }
    case SEARCH_SUCCESS:
      return {
        ...state,
        querystring: payload.querystring,
        results: payload.result,
        searching: false,
        error: '',
        status: payload.status
      }
    case SEARCH_ERROR:
      return {
        ...state,
        error: payload,
        searching: false,
        status: ''
      }

    case SEARCH_MY_ALIADAS_STARTED:
      return {
        ...state,
        searchingMyAliadas: true
      }
    case SEARCH_MY_ALIADAS_SUCCESS:
      return {
        ...state,
        myAliadasResults: payload.result,
        searchingMyAliadas: false
      }
    case SEARCH_MY_ALIADAS_ERROR:
      return {
        ...state,
        myAliadasResults: [],
        searchingMyAliadas: false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/search.js